<template>
	<div>
		<loading v-if="!loaded" />
		<el-tabs v-model="tabName" v-if="loaded">
			<el-tab-pane label="សាខាទាំងអស់" name="first"></el-tab-pane>
			<el-tab-pane label="បង្កើតសាខាថ្មី" name="second"></el-tab-pane>
		</el-tabs>
		<div v-if="tabName == 'first' && loaded">
			<div class="md-layout">
				<div class="md-layout-item md-small-size-100 md-size-40">
					<md-field>
						<label>ស្វែងរកតាមរយៈ ឈ្មោះ ឬលេខកូដ</label>
						<md-input v-model="search.text" type="text" @keyup.enter="searchHandler()"></md-input>
					</md-field>
				</div>
				<div class="md-layout-item md-size-30">
					<md-button class="md-raised md-primary" @click="searchHandler()" style="width: 100%">ស្វែងរក</md-button>
				</div>
			</div>

			<md-table v-if="branchList.length > 0">
				<md-table-row>
					<md-table-head>ល.រ</md-table-head>
					<md-table-head>លេខកូដ</md-table-head>
					<md-table-head>ឈ្មោះ</md-table-head>
					<md-table-head>ចំនួនសមាជិក</md-table-head>
					<md-table-head>ចំណាំ</md-table-head>
					<md-table-head>ថ្ងៃបង្កើត</md-table-head>
					<md-table-head>សកម្មភាព</md-table-head>
				</md-table-row>

				<md-table-row v-for="(branch, index) in branchList">
					<md-table-cell>{{ index + 1 }}</md-table-cell>
					<md-table-cell><b>{{ branch.code }}</b></md-table-cell>
					<md-table-cell><b>{{ branch.name }}</b></md-table-cell>
					<md-table-cell>
						<b v-if="branch.total_client != null">{{ branch.total_client }} នាក់</b>
						<b v-else>0 នាក់</b>
					</md-table-cell>
					<md-table-cell><b>{{ branch.note }}</b></md-table-cell>
					<md-table-cell><b>{{ config.datelify(branch.created_date) }}</b></md-table-cell>
					<md-table-cell>
						<router-link :to="'/branch/detail/' + branch.hash">
							<md-button class="md-just-icon md-simple md-success">
								<md-icon>visibility</md-icon>
								<md-tooltip md-direction="top">បង្ហាញបន្ថែម</md-tooltip>
							</md-button>
						</router-link>
						<router-link :to="'/branch/edit/' + branch.hash">
							<md-button class="md-just-icon md-simple md-info">
								<md-icon>edit</md-icon>
								<md-tooltip md-direction="top">កែប្រព័ត៌មាន</md-tooltip>
							</md-button>
						</router-link>
						<!-- <md-button class="md-just-icon md-simple md-info">
							<md-icon>edit</md-icon>
							<md-tooltip md-direction="top">Edit client information</md-tooltip>
						</md-button>

						<md-button class="md-just-icon md-simple md-danger">
							<md-icon>close</md-icon>
							<md-tooltip md-direction="top">Delete this client</md-tooltip>
						</md-button> -->
					</md-table-cell>
				</md-table-row>
			</md-table>

			<h4 class="text-center" v-if="branchList.length == 0 && loadMore == true">មិនមានអ្នកទីផ្សារ</h4>
			<div class="places-buttons text-center" v-if="loadMore">
				<md-button class="md-primary" @click="searchHandler(true)">បង្ហាញបន្ថែម</md-button>
			</div>
		</div>



		<div v-if="tabName == 'second'">
			<div class="md-layout">
				<div class="md-layout-item md-small-size-100 md-size-50">
					<div class="md-layout-item md-small-size-100 md-size-100">
						<h3>ព័ត៌មានអំពីសាខា</h3>
					</div>
					<div class="md-layout-item md-small-size-100 md-size-100 text-right">
						<span class="late">* តម្រូវឱ្យបំពេញ</span>
					</div>
					<div class="md-layout">
						<div class="md-layout-item md-small-size-100 md-size-100">
							<md-field>
								<label>ឈ្មោះសាខា *</label>
								<md-input type="text" v-model="branch.name"></md-input>
							</md-field>
						</div>
					</div>
					<div class="md-layout">
						<div class="md-layout-item md-small-size-100 md-size-100">
							<md-field>
								<label>កំណត់ចំណាំ</label>
								<md-input type="text" v-model="branch.note"></md-input>
							</md-field>
						</div>
					</div>
				</div>
				<div class="md-layout-item md-small-size-100 md-size-50">
					<div class="md-layout-item md-small-size-100 md-size-100">
						<h3>ព័ត៌មានសង្ខេប</h3>
					</div>
					<div class="md-layout-item md-small-size-100 md-size-100">
						<md-table>
							<md-table-row>
								<md-table-cell style="width: 50%;">ឈ្មោះសាខា</md-table-cell>
								<md-table-cell style="width: 5px">:</md-table-cell>
								<md-table-cell>
									<span v-if="String(branch.name).length > 0">{{branch.name}}</span>
									<span v-else>មិនទាន់មាន</span>
								</md-table-cell>
							</md-table-row>
							<md-table-row>
								<md-table-cell>កំណត់ចំណាំ</md-table-cell>
								<md-table-cell>:</md-table-cell>
								<md-table-cell>
									<span v-if="String(branch.note).length > 0">{{branch.note}}</span>
									<span v-else>មិនទាន់មាន</span>
								</md-table-cell>
							</md-table-row>
						</md-table>
					</div>
				</div>
				<div class="md-layout-item md-size-100 text-right">
					<md-button class="md-raised md-primary" @click="postBranch()">បង្កើត</md-button>
				</div>
			</div>

		</div>
	</div>

	<!-- <md-dialog-confirm :md-active.sync="deleteDialogActive" md-title="តើអ្នកពិតជាចង់លុបក្រុមហ៊ុននេះពិតមែនទេ ?"
			md-content="ព័ត៌មានក្រុមហ៊ុននឹងត្រូវបានលុបចេញពីបញ្ជីជារាងរហូត។" md-confirm-text="លុប" md-cancel-text="បោះបង់"
			@md-cancel="onCancel" @md-confirm="onDelete" /> -->
	</div>

</template>

<script>
	import { Datetime } from 'vue-datetime';
	export default {
		components: { Datetime },
		created() {
			this.searchHandler();
		},

		data() {
			return {
				tabName: "first",
				loaded: false,
				deleteDialogActive: false,
				deleteSelected: '',
				search: {
					text: ""
				},
				branch: {
					name: "",
					note: ""
				},
				loadMore: true,
				branchList: []

			}
		},
		methods: {
			postBranch() {
				if (!this.checkValidation()) return false;
				this.$http.post(this.config.api + "/admin/branch/post", {
					branch: this.branch
				}).then(data => {
					if (data.body.status == 'success') {
						this.tabName = 'first'
						this.$notification.notify({
							message: "អ្នកផ្ញើរឥវ៉ាន់ត្រូវបានបង្កើតដោយជោគជ័យ។",
							icon: 'done',
							type: 'success'
						});
						this.search.text = "";
						this.searchHandler();
						this.clearAll();
					}
					// this.loadMoreCompanyButton = true

				})
			},
			searchHandler(more = false) {
				this.$http.post(this.config.api + "/admin/branch/search", {
					text: this.search.text,
					offset: more ? this.branchList.length : 0
				}).then(data => {
					this.loaded = true;
					this.search.text = "";
					if (data.body.data.length == 100) this.loadMore = true;
					else this.loadMore = false;
					this.branchList = more ? this.branchList.concat(data.body.data) : data.body.data;
					// this.referralList = data.body.data;
				})
			},
			checkValidation() {
				if (String(this.branch.name).length > 0) {
					return true;
				} else {
					this.$notification.notify({
						message: "សូមបញ្ចូលព័ត៌មាន។",
						icon: 'info',
						type: 'warning'
					});
					return false;
				}
			},
			clearAll() {
				this.search.text = "";
				this.branch = {
					name: "",
					note: ""
				}
			}
		}
	}
</script>
<style scoped>
	.product-thumbnail {
		width: 64px;
		height: 64px;
	}

	.grid-8 {
		text-align: center;
		max-width: 20%;
		min-width: 20%;
		flex: 0 0 20%;
	}

	.thumb-product {
		width: 50%;
	}
</style>



// WEBPACK FOOTER //
// src/pages/Branch/View.vue